import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Renders shared event branding, route shortcuts, and support contact details.
import { Link } from "react-router-dom";
import logo from "../../assets/updatedLogo2.png";
import { showConferencePages } from "../../config/featureFlags";
import "./Footer.scss";
const quickLinks = [
    { label: "Home", to: "/" },
    ...(showConferencePages
        ? [
            { label: "Speakers", to: "/speakers" },
            { label: "Schedule", to: "/schedule" },
        ]
        : []),
    { label: "Media", to: "/media" },
    ...(showConferencePages ? [{ label: "Register", to: "/register" }] : []),
];
const contactDetails = [
    {
        label: "Email",
        value: "contact@youth4god.org",
        href: "mailto:contact@youth4god.org",
    },
    { label: "Location", value: "Sacramento, CA" },
];
const socialLinks = [
    {
        label: "Instagram",
        href: "https://www.instagram.com/youth4godcon/",
    },
];
export function Footer() {
    const currentYear = new Date().getFullYear();
    return (_jsxs("footer", { className: "footer", children: [_jsxs("div", { className: "container footer__grid", children: [_jsxs("div", { className: "footer__brand", children: [_jsx(Link, { to: "/", "aria-label": "Youth for God home", children: _jsx("img", { className: "footer__logo", src: logo, alt: "Youth for God" }) }), _jsx("p", { children: "Youth for God conference exists to elevate Christ and equip the next generation through gospel centered preaching, worship and community." }), _jsx("div", { className: "footer__social", "aria-label": "Social links", children: socialLinks.map((link) => (_jsx("a", { href: link.href, target: "_blank", rel: "noopener noreferrer", children: link.label }, link.label))) })] }), _jsxs("div", { className: "footer__links", children: [_jsx("h4", { children: "Quick Links" }), _jsx("ul", { children: quickLinks.map((link) => (_jsx("li", { children: _jsx(Link, { to: link.to, children: link.label }) }, link.label))) })] }), _jsxs("div", { className: "footer__contact", children: [_jsx("h4", { children: "Contact" }), _jsx("ul", { children: contactDetails.map((item) => (_jsxs("li", { children: [_jsxs("span", { children: [item.label, ":"] }), " ", item.href ? (_jsx("a", { href: item.href, children: item.value })) : (_jsx("span", { children: item.value }))] }, item.label))) })] })] }), _jsx("div", { className: "footer__bottom", children: _jsxs("p", { className: "footer__copy", children: ["\u00A9 ", currentYear, " Youth for God Conference. All rights reserved."] }) })] }));
}
